import { useState } from "react";
import { Plug, HeartPulse, FileCode } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { PageHeader } from "@/components/design-system";
import InstallationTab from "@/pages/InstallationTab";
import XmlConnectionWizard from "@/pages/XmlConnectionWizard";

/* ============================================================================
   SİSTEM > ENTEGRASYON
   ----------------------------------------------------------------------------
     • Kurulum       — Bağlı Mağaza (read-only) + Bağlantı Durumu (HEAD + Meta)
                       birleşik kart. Saat başı otomatik + manuel test.
     • XML Bağlantısı — Ürün kataloğu XML feed wizard'ı (URL → Mapping → Preview → Sync).
============================================================================ */
export default function Integration() {
    const { t } = useI18n();
    const [active, setActive] = useState("installation");

    const tabs = [
        { id: "installation", label: t("integration.tabs.installation"), icon: HeartPulse },
        { id: "xml",          label: t("integration.tabs.xml"),          icon: FileCode },
    ];

    return (
        <div className="space-y-6" data-testid="integration-page">
            <PageHeader
                icon={Plug}
                title={t("integration.title")}
                description={t("integration.subtitle")}
            />

            <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6" data-testid="integration-tabs">
                <nav className="space-y-0.5 self-start lg:sticky lg:top-20">
                    {tabs.map((tb) => (
                        <button
                            key={tb.id}
                            onClick={() => setActive(tb.id)}
                            data-testid={`integration-tab-${tb.id}`}
                            className={`w-full flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors ${
                                active === tb.id ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
                            }`}
                        >
                            <tb.icon className="h-4 w-4" strokeWidth={1.5} />
                            <span>{tb.label}</span>
                        </button>
                    ))}
                </nav>

                <div>
                    {active === "installation" && <InstallationTab />}
                    {active === "xml" && <XmlConnectionWizard />}
                </div>
            </div>
        </div>
    );
}
